import { render } from "./uk3.vue?vue&type=template&id=731bfddd"
import script from "./uk3.vue?vue&type=script&lang=js"
export * from "./uk3.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__